<page-title text="BitOasis | About Us" i18n-text="@@pageTitle.aboutUs"></page-title>

<site-header></site-header>

<header class="header">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <div class="content h-100">
          <div class="text">
            <h1 class="title" i18n="@@front.aboutUs.header.title">About Us</h1>
            <p i18n="@@front.aboutUs.header.description">Headquartered in the UAE, BitOasis is the largest and most trusted cryptocurrency platform in the MENA region. Established in 2015, BitOasis is a pioneer of the region's cryptocurrency ecosystem, serving as the go-to platform for first-time crypto asset buyers and professional traders alike. BitOasis aims to offer the most secure and regulated infrastructure in cryptocurrency trading for retail and institutional clients across the region.</p>
          </div><!-- .text -->
          <div class="nav">
            <!-- <a class="active" (click)="scrollTo('management')" i18n="@@front.aboutUs.menu.team">Team</a> -->
            <a class="active" (click)="scrollTo('vision-mission')" i18n="@@front.aboutUs.menu.vision">Vision & Mission</a>
            <a (click)="scrollTo('investors')" i18n="@@front.aboutUs.menu.investors">Investors</a>
            <a (click)="scrollTo('compliance')" i18n="@@front.aboutUs.menu.compliance">Regulatory Compliance</a>
          </div>
          <div class="spacer"></div>
        </div><!-- .content -->
      </div><!-- .col-lg-6 -->
      <div class="col-lg-6">
        <img class="img" src="assets/images/about-us/header.png" alt="About BitOasis" i18n-alt="@@front.aboutUs.header.image">
      </div><!-- .col-lg-6 -->
    </div>
  </div>
</header>

<!-- <section id="management" class="section management">
  <div class="container">
    <h1 i18n="@@front.aboutUs.team.title">Management Team</h1>

    <div class="team">
      <div class="member">
        <img class="img" src="assets/images/about-us/team/ola.png" alt="Ola Doudin">
        <div class="spacer"></div>
        <div class="content">
          <div class="title">
            <h2 class="name" i18n="@@front.aboutUs.team.ola.name">Ola Doudin</h2>
            <div class="social">
              <a href="https://www.linkedin.com/in/ola-doudin-5a026511/" target="_blank" class="linkedin"><img src="assets/images/about-us/social/linkedin.svg" alt="Linkedin"></a>
              <a href="https://twitter.com/odoudin" target="_blank" class="twitter"><img src="assets/images/about-us/social/twitter.svg" alt="Twitter"></a>
            </div>
          </div>
          <h3 class="position" i18n="@@front.aboutUs.team.ola.position">CEO and Co-Founder</h3>
          <p class="text" i18n="@@front.aboutUs.team.ola.description">In 2015, Ola Doudin became a pioneer in the region’s cryptocurrency ecosystem when she co-founded BitOasis, the first and largest crypto asset platform in the Middle East. With a background in engineering, Ola started her career in IT Risk Advisory at Ernst & Young in London while involved in entrepreneurship, investing and mentoring tech startups. She also worked with Fadi Ghandour and Aramex management.</p>
        </div>
      </div>

      <div class="member">
        <img class="img" src="assets/images/about-us/team/daniel.png" alt="Daniel Robenek">
        <div class="spacer"></div>
        <div class="content">
          <div class="title">
            <h2 class="name" i18n="@@front.aboutUs.team.daniel.name">Daniel Robenek</h2>
            <div class="social">
              <a href="https://www.linkedin.com/in/danielrobenek/" target="_blank" class="linkedin"><img src="assets/images/about-us/social/linkedin.svg" alt="Linkedin"></a>
            </div>
          </div>
          <h3 class="position" i18n="@@front.aboutUs.team.daniel.position">CTO and Co-Founder</h3>
          <p class="text" i18n="@@front.aboutUs.team.daniel.description">Daniel is focused on leading and growing the company’s engineering team, maintaining system security and scalability. Daniel holds his Bachelor and Master’s degree in Computer Science and before dropping out of his PhD to join BitOasis, his doctoral degree research was focused on supercomputers for biomedicine DNA analysis. He has submitted and published articles on data structure efficiency and DNA sequence assembly.</p>
        </div>
      </div>

      <div class="member">
        <img class="img" src="assets/images/about-us/team/motaz.png" alt="Motaz Nofal">
        <div class="spacer"></div>
        <div class="content">
          <div class="title">
            <h2 class="name" i18n="@@front.aboutUs.team.motaz.name">Motaz Nofal</h2>
            <div class="social">
              <a href="https://www.linkedin.com/in/motaz-nofal/" target="_blank" class="linkedin"><img src="assets/images/about-us/social/linkedin.svg" alt="Linkedin"></a>
            </div>
          </div>
          <h3 class="position" i18n="@@front.aboutUs.team.motaz.position">COO - Chief Operating Officer</h3>
          <p class="text" i18n="@@front.aboutUs.team.motaz.description">Motaz has over 17 years of experience in strategy, operations, customer experience, digital and the startup ecosystem. He has a proven track record of accomplishments, working with and advising multiple start-ups across the region and at various growth stages. He has vast corporate experience in leading regional and global teams and expanding companies through organic, M&A and franchising initiatives.</p>
        </div>
      </div>

      <div class="member">
        <img class="img" src="assets/images/about-us/team/doris.png" alt="Doris Kayode">
        <div class="spacer"></div>
        <div class="content">
          <div class="title">
            <h2 class="name" i18n="@@front.aboutUs.team.doris.name">Doris Kayode</h2>
            <div class="social">
              <a href="https://www.linkedin.com/in/doris-kayode-7505a33b/" target="_blank" class="linkedin"><img src="assets/images/about-us/social/linkedin.svg" alt="Linkedin"></a>
            </div>
          </div>
          <h3 class="position" i18n="@@front.aboutUs.team.doris.position">CCO - Chief Compliance Officer</h3>
          <p class="text" i18n="@@front.aboutUs.team.doris.description">Doris is responsible for managing all aspects of regulatory compliance, anti-money laundering compliance and risk. Doris has over 17 years of legal and compliance experience in the financial industry, specifically in capital markets. She has a Masters in Law and an International Diploma in Compliance.</p>
        </div>
      </div>

      <div class="member">
        <img class="img" src="assets/images/about-us/team/mika.png" alt="Mika Thompson">
        <div class="spacer"></div>
        <div class="content">
          <div class="title">
            <h2 class="name" i18n="@@front.aboutUs.team.mika.name">Mika Thompson</h2>
            <div class="social">
              <a href="https://www.linkedin.com/in/mika-thompson-1a93567/" target="_blank" class="linkedin"><img src="assets/images/about-us/social/linkedin.svg" alt="Linkedin"></a>
            </div>
          </div>
          <h3 class="position" i18n="@@front.aboutUs.team.mika.position">Senior VP - Finance</h3>
          <p class="text" i18n="@@front.aboutUs.team.mika.description">MMika has over 19 years of corporate experience across various sectors, including technology, media, commodities, security and hospitality. With exposure to global, multi-billion-dollar organizations and start-up environments, she has developed her strengths for change management, process improvement and implementation of effective internal controls.</p>
        </div>
      </div>

      <div class="member">
        <img class="img" src="assets/images/about-us/team/srinu.png" alt="Srinu Chowan">
        <div class="spacer"></div>
        <div class="content">
          <div class="title">
            <h2 class="name" i18n="@@front.aboutUs.team.srinu.name">Srinu Chowan</h2>
            <div class="social">
              <a href="https://www.linkedin.com/in/srinu-growth-marketing/" target="_blank" class="linkedin"><img src="assets/images/about-us/social/linkedin.svg" alt="Linkedin"></a>
              <a href="https://twitter.com/srinualways" target="_blank" class="twitter"><img src="assets/images/about-us/social/twitter.svg" alt="Twitter"></a>
            </div>
          </div>
          <h3 class="position" i18n="@@front.aboutUs.team.srinu.position">VP - Marketing and Growth</h3>
          <p class="text" i18n="@@front.aboutUs.team.srinu.description">Srinu is one of the industry thought leaders when it comes to marketing and growth initiatives. He has worked across multiple industries like travel metasearch, ecommerce and blockchain (cryptocurrency).<br/>He has a consistent track record of growing companies from start-up to scale up and is a certified growth leader by Growth Tribe and mentor startups at Seedstars.</p>
        </div>
      </div>

      <div class="member">
        <img class="img" src="assets/images/about-us/team/fadi.png" alt="Fadi Bachir">
        <div class="spacer"></div>
        <div class="content">
          <div class="title">
            <h2 class="name" i18n="@@front.aboutUs.team.fadi.name">Fadi Bachir</h2>
            <div class="social">
              <a href="https://www.linkedin.com/in/fadi-ibrahim-bachir-96ab9413/" target="_blank" class="linkedin"><img src="assets/images/about-us/social/linkedin.svg" alt="Linkedin"></a>
            </div>
          </div>
          <h3 class="position" i18n="@@front.aboutUs.team.fadi.position">VP - People</h3>
          <p class="text" i18n="@@front.aboutUs.team.fadi.description">Fadi Bachir is a human resources expert with a broad background in strategic HR and more than 16 years of experience across different international and multinational global industries, from higher education to internet and retail. Fadi has developed and implemented best practices in human resources and has a flair for creating work environments that attract and retain top-notch talent. Throughout his career, Fadi found satisfaction in bringing improvements to the workplace.</p>
        </div>
      </div>

    </div>
  </div>
</section> -->

<section id="vision-mission" class="section vision-mission gray-bg">
  <div class="container">
    <div class="centered-text">
      <h1 class="title" i18n="@@front.aboutUs.vision.title">Vision</h1>
      <p class="text quote" i18n="@@front.aboutUs.vision.description">We believe that cryptocurrencies will be the building blocks to a new digital financial system that is more transparent and inclusive and we’re focused on building the infrastructure to realize this potential.</p>
    </div>
    
    <div class="centered-text">
      <h1 class="title" i18n="@@front.aboutUs.mission.title">Mission</h1>
      <p class="text" i18n="@@front.aboutUs.mission.description">To be the leading cryptocurrency platform in the region and provide an easy to use, secure and compliant way to buy, sell and trade crypto assets in the Middle East.</p>
    </div>

    <div class="goals row">
      <div class="col-lg">
        <div class="goal">
          <img src="assets/images/about-us/goals/goal.svg" alt="">
          <h3 class="text-md text-bold mb-3" i18n="@@front.aboutUs.goals.goal1.title">Digital assets to millions of people</h3>
          <p class="text-sm text-gray" i18n="@@front.aboutUs.goals.goal1.description">We aim to have a positive impact and drive adoption of crypto assets in the Middle East and beyond</p>
        </div>
      </div>
  
      <div class="col-lg">
        <div class="goal">
          <img src="assets/images/about-us/goals/secure.svg" alt="">
          <h3 class="text-md text-bold mb-3" i18n="@@front.aboutUs.goals.goal2.title">Security as a standard</h3>
          <p class="text-sm text-gray" i18n="@@front.aboutUs.goals.goal2.description">We ensure the highest levels of security at all times with continuous vigilance.</p>
        </div>
      </div>
  
      <div class="col-lg">
        <div class="goal">
          <img src="assets/images/about-us/goals/individual.svg" alt="">
          <h3 class="text-md text-bold mb-3" i18n="@@front.aboutUs.goals.goal3.title">Champion the individual</h3>
          <p class="text-sm text-gray" i18n="@@front.aboutUs.goals.goal3.description">Our products are inspired by our users and we continuously engage and listen to our community across the region.</p>
        </div>
      </div>
  
      <div class="col-lg">
        <div class="goal">
          <img src="assets/images/about-us/goals/success.svg" alt="">
          <h3 class="text-md text-bold mb-3" i18n="@@front.aboutUs.goals.goal4.title">Focus on customer success</h3>
          <p class="text-sm text-gray" i18n="@@front.aboutUs.goals.goal4.description">We put the safety and convenience of our customers first and we aim to provide the best-in-class experience.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="investors" class="section investors">
  <div class="container">
    <h1 i18n="@@front.aboutUs.investors.title">Investors</h1>
    <div class="logos">
      <a href="https://jumpcap.com" target="_blank"><img src="assets/images/about-us/investors/jump-capital.svg" alt="Jump Capital"></a>
      <a href="https://panteracapital.com" target="_blank"><img src="assets/images/about-us/investors/pantera.svg" alt="Pantera"></a>
      <a href="https://wamdacapital.com" target="_blank"><img src="assets/images/about-us/investors/wamda.svg" alt="Wamda Capital"></a>
      <a href="https://dcg.co" target="_blank"><img src="assets/images/about-us/investors/digital-currency-group.svg" alt="Digital Currency Group"></a>
      <!-- <a href="https://www.alameda-research.com" target="_blank"><img src="assets/images/about-us/investors/alameda.svg" alt="Alameda Research"></a> -->
      <a href="https://www.nxmh.com" target="_blank"><img src="assets/images/about-us/investors/nxmh.svg" alt="NXMH"></a>
      <a href="https://www.globalfounderscapital.com" target="_blank"><img src="assets/images/about-us/investors/gfc.svg" alt="GFC"></a>
    </div>
  </div>
</section>

<section id="compliance" class="section compliance gray-bg mb-0">
  <div class="container">

    <h1 i18n="@@front.aboutUs.compliance.title">Regulatory Compliance</h1>

    <h4 i18n="@@front.aboutUs.compliance.line2">UAE FIU Registered Entity</h4>
    <p i18n="@@front.aboutUs.compliance.line1">BitOasis became registered as a Reporting Entity on UAE FIU GoAML Anti-Money Laundering System in September 2021.</p>

    <h4 i18n="@@front.aboutUs.compliance.line3">Virtual Asset Regulatory Authority (VARA)</h4>
    <p i18n="@@front.aboutUs.compliance.line4">Virtual Asset Regulatory Authority (VARA) is the virtual asset regulator established under Dubai Law No. 4 of 2022 to regulate, supervise and oversee all virtual asset services within the Emirate of Dubai.<br/>Following the establishment of VARA, BitOasis has secured VARA's provisional approval to continue its operations in Dubai. BitOasis is currently in the process of obtaining an MVP license from VARA.</p>

    <p i18n="@@front.aboutUs.compliance.line8">Please refer to our <a routerLink="/page/code-of-ethics">Code of Ethics</a> and <a routerLink="/page/aml-policy">AML & Compliance policy</a>.</p>
  </div>
</section>

<site-footer></site-footer>